var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('mainLoading'),_c('main',{style:(_vm.$store.state.utils.loaded ? 'display: block' : 'display: none')},[_c('mainNotifications'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }